import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const studentIcon = new L.Icon({
  iconUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.7/dist/images/marker-icon.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});
const teacherIcon = new L.Icon({
  iconUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.7/dist/images/marker-icon.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

export function MapModal({ open, onClose, student, teacher }) {
  if (!open) return null;
  if (!student || !student.lat || !student.lon) return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-lg w-[400px] max-w-full">
        <h2 className="font-bold text-lg mb-2">Map</h2>
        <div className="text-red-500">Student location not available.</div>
        <button className="mt-4 px-4 py-2 bg-gray-600 text-white rounded" onClick={onClose}>Close</button>
      </div>
    </div>
  );
  const center = [student.lat, student.lon];
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded shadow-lg w-[90vw] max-w-2xl">
        <h2 className="font-bold text-lg mb-2">Location on Map</h2>
        <div className="mb-4" style={{ height: 350, width: '100%' }}>
          <MapContainer center={center} zoom={13} scrollWheelZoom={true} style={{ height: 350, width: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={center} icon={studentIcon}>
              <Popup>Student</Popup>
            </Marker>
            {teacher && teacher.lat && teacher.lon &&
              <Marker position={[teacher.lat, teacher.lon]} icon={teacherIcon}>
                <Popup>Teacher</Popup>
              </Marker>
            }
          </MapContainer>
        </div>
        <button className="px-4 py-2 bg-gray-600 text-white rounded" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

